export const SITE = {
  name: "Neurogility",
  tagline: "Building the skills people need to live a better life.",
  phone: "1300 798 265",
  email: "info@neurogility.com.au",
  address: "6 Mount Street, Glen Waverley, Victoria",
  hours: "Mon–Fri · 8:30am – 4:30pm",
  logo: "https://customer-assets.emergentagent.com/job_recovery-hub-142/artifacts/0mp3lubx_Untitled%20design%285%29.png",
  ndisLogo: "https://customer-assets.emergentagent.com/job_recovery-hub-142/artifacts/u1qyvg5d_We%20heart%20NDIS%20Registered%20provider%20logo%20-%20Short.png",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/program", label: "Program" },
  { to: "/approach", label: "Approach" },
  { to: "/ndis-services", label: "NDIS Services" },
  { to: "/professionals", label: "For Professionals" },
  { to: "/contact", label: "Contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1724167934723-6ca990cb8a15?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  approach: "https://images.unsplash.com/photo-1687181133399-668ddc50065c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  group: "https://images.unsplash.com/photo-1646066489838-aa1eddbe5964?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  nature: "https://images.unsplash.com/photo-1502082553048-f009c37129b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  hands: "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  team: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};
